import type { Answers, Groups } from "../../../features/questionnaire";

// Pure helper: collects all `${name}[Label]` numeric answers and returns a
// simple comma-separated string of numbers (e.g. "40,60,0").
export const buildPercentagesAnswer = (
  name: string,
  answers: Answers,
): string => {
  const prefix = `${name}[`;
  const parts: number[] = [];
  for (const [k, v] of Object.entries(answers)) {
    if (k.startsWith(prefix) && k.endsWith("]")) {
      const num = Number(v);
      if (Number.isFinite(num) && num >= 0) {
        parts.push(num);
      }
    }
  }
  return parts.join(",");
};

// Pure helper: collects percentage values from group question names.
// Used for percentage_split_group questions where answers use individual
// question names (e.g. "business_use", "personal_use") instead of bracket notation.
// Strips "%" suffix from answers and excludes readonly total question (last in names array).
export const buildPercentagesAnswerForGroup = (
  name: string,
  groups: Groups,
  answers: Answers,
): string => {
  const group = groups[name];
  if (!group || group.kind !== "percent") {
    return "";
  }

  // Exclude readonly total question (last in names array)
  const regularQuestionNames = group.names.slice(0, -1);

  const parts: number[] = [];
  for (const questionName of regularQuestionNames) {
    const value = answers[questionName];
    if (value === undefined || value === null || value === "") {
      continue;
    }
    // Remove % suffix and convert to number
    const num = Number(String(value).replace(/%/g, ""));
    if (Number.isFinite(num) && num >= 0) {
      parts.push(num);
    }
  }
  return parts.join(",");
};
